import { render, staticRenderFns } from "./StButtonTrans.vue?vue&type=template&id=0d225470&"
import script from "./StButtonTrans.vue?vue&type=script&lang=js&"
export * from "./StButtonTrans.vue?vue&type=script&lang=js&"
import style0 from "./StButtonTrans.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports